/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const AnnotateIcon = ({ width = 24, height = 24, hidden = false, title = 'Annotate' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M24 32v-7a1 1 0 0 1 1-1h7a1.161 1.161 0 0 1-.254.854l-6.892 6.892A1.161 1.161 0 0 1 24 32Z"
    />
    <path
      d="M31 4H5a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1h17v-8a2 2 0 0 1 2-2h8V5a1 1 0 0 0-1-1ZM18 24h-8v-2h8Zm8-6H10v-2h16Zm0-6H10v-2h16Z"
    />
  </svg>`;
};
